import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, Redirect } from 'react-router-dom'
import {
    Container,
    Description,
    LotsSectionWrapper,
    Title,
    ToggleIcon,
    ToggleText,
    ViewContainer
} from './CityLandingPage.style'
import LotViewToggle from '@components/LotViewToggle/LotViewToggle.component'
import DisabledMap from '@components/LotsMap/DisabledMap'
import LotsMap from '@components/LotsMap/LotsMap'
import LotListView from '@views/Search/components/LotListView/LotListView.component'
import { ConsentContext } from '@context/ConsentProvider/ConsentProvider'
import { SeoHead } from '@components/SeoHead/SeoHead.component'
import { searchRoute } from '@views/Search/route'
import { notFoundRoute } from '@views/404/route.const'
import { useLandingPageMeta, useHreflangs, useSearchedLocation } from './landingPages.hook'
import { useFetchLots } from '@hooks/useFetchLots.hook'

const CityLandingPage = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const { allowGoogleMaps: allowGoogleMapsConsent } = useContext(ConsentContext)

    const { landingPage, metaTags } = useLandingPageMeta()
    const searchedLocation = useSearchedLocation(landingPage)
    const hreflangs = useHreflangs(landingPage)
    const { publicLots } = useFetchLots(searchedLocation)

    const [view, setView] = useState<'list' | 'map'>('list')
    const [lotMapSelected, setLotMapSelected] = useState(false)

    // if missing translations, redirect to 404
    if (!landingPage || !landingPage.translations.title) return <Redirect to={notFoundRoute()} />

    return (
        <>
            <SeoHead title={metaTags?.metaTitle} description={metaTags?.metaDescription} hreflangs={hreflangs} />
            <Container>
                <Title>{landingPage.translations.title}</Title>
                <Description>{landingPage.translations.description}</Description>
                <ViewContainer>
                    {view === 'list' ? (
                        <LotsSectionWrapper>
                            <LotListView
                                searchable
                                searchedLocation={searchedLocation}
                                showTitleAndCount={false}
                                onSearchReset={() => history.push(searchRoute())}
                            />
                        </LotsSectionWrapper>
                    ) : allowGoogleMapsConsent ? (
                        <LotsMap
                            publicLots={publicLots}
                            searchedLocation={searchedLocation}
                            setLotMapSelected={setLotMapSelected}
                        />
                    ) : (
                        <DisabledMap />
                    )}
                </ViewContainer>

                <LotViewToggle
                    cardShown={view === 'map' && lotMapSelected}
                    onClick={() => setView(view === 'list' ? 'map' : 'list')}
                >
                    <ToggleIcon
                        className={`${view === 'list' ? 'wemolo-map-search' : 'pkd-list'}`}
                        aria-hidden="true"
                    />
                    <ToggleText>{view === 'list' ? t('search.map') : t('search.list')}</ToggleText>
                </LotViewToggle>
            </Container>
        </>
    )
}

export default CityLandingPage
